module.exports = __webpack_public_path__ + "static/media/certificate-2014.58408c9b.jpeg";